<app-input-wrapper
  [required]="required"
  [errorMessage]="control?.errors"
  [touched]="!control?.untouched"
  [disabled]="disabled"
  [readonly]="readonly ?? false"
  [label]="(readonly && readonlyAsText) ? label : undefined"
>

  <ng-container *ngIf="readonly && readonlyAsText">
    <input pInputText [readonly]="true"
           [attr.aria-label]="label" [value]="value ?? false"
    >
  </ng-container>
  <ng-container *ngIf="!readonly || !readonlyAsText">
    <div class="checkbox">
      <p-checkbox
        [name]="label"
        [value]="value"
        [label]="label"
        [binary]="true"
        [disabled]="disabled"
        [readonly]="readonly ?? false"
        [inputId]="inputID"
        [ngModel]="value"
        [pTooltip]="tooltip"
        (onChange)="handleCheckboxChange($event)"
      ></p-checkbox>
    </div>
  </ng-container>
</app-input-wrapper>
